export default __webpack_public_path__ + "static/media/ai_color_trackingActive.3cffd843.svg";